module.exports = ".btnTDownload .download-btn {\n  color: rgba(0, 0, 0, 0.65);\n}\n"